import axios from 'axios';
class Material {
    constructor(initData) {
        const { container, url, loaded, style, tokenUrl } = initData;
        this.self = this;
        this.url = url;
        this.cbList = {};
        this.tokenUrl = tokenUrl;
        this.cbList['loaded'] = loaded; // 加载完成执行
        this.cbList['getToken'] = this.getToken.bind(this); // 加载完成执行
        this.iframeDom = document.createElement('iframe');
        this.iframeDom.src = this.url;
        let defaultStyle = {
            border: 0,
        };
        Object.assign(this.iframeDom.style, defaultStyle, style);
        document.querySelector(container).appendChild(this.iframeDom);
        window.addEventListener(
            'message',
            this.handleMessage.bind(this),
            false
        );
    }
    async getToken(event, data) {
        debugger;
        const res = await axios.get(this.tokenUrl, {
            params: {
                url: data.url,
            },
        });
        if (res.status === 200 && res.data.code === 0) {
            this.send({
                type: 'getToken',
                data: {
                    url: data.url,
                    token: res.data.data,
                },
            });
        }
    }
    handleMessage(event) {
        // 回调事件
        console.log(event);
        const { type, data } = event.data;
        this.cbList[type] && this.cbList[type](this.iframeDom, data);
    }
    on(event, cb) {
        // 事件监听
        this.cbList[event] = cb;
    }
    send({ type, data }) {
        debugger;
        // 发送事件
        try {
            this.iframeDom.contentWindow.postMessage(
                {
                    type,
                    data: data || '',
                },
                '*'
            );
        } catch (error) {}
    }
}
window.Material = Material;
export default Material;
